module.exports = __webpack_public_path__ + "static/media/MappaRosa.bdf90a0e.jpg";